import { render, staticRenderFns } from "./EditViewTermReportsSubjectRow.vue?vue&type=template&id=6922caab&scoped=true&"
import script from "./EditViewTermReportsSubjectRow.vue?vue&type=script&lang=js&"
export * from "./EditViewTermReportsSubjectRow.vue?vue&type=script&lang=js&"
import style0 from "./EditViewTermReportsSubjectRow.vue?vue&type=style&index=0&id=6922caab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922caab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSelect,VTextField})
